import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { api } from "../../../utils/Api";
import { omit } from "lodash";
import { useParams } from "react-router-dom";

const initial_value = {
  id: "",
  created_username: "",
  amount: "",
  user: "",
  username: "",
  profile_picture: "",
  created_at: "",
  created_user: "",
};
let myModal = {};

export default function ModelViewMonthlySalary(props: any) {
  const [save_data, SetSaveData] = useState(initial_value);
  const [close_data, SetCloseData] = useState({
    action: "close",
  });

  useEffect(() => {
    console.log("ModelViewMonthlySalary On mount :", props);
    let myModal1 = document.getElementById("ModelViewMonthlySalary");
    myModal1.addEventListener("hidden.bs.modal", function (event) {
      console.log("event :", event);
      console.log("close_data :", close_data);
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.data.is_open) {
      console.log("ModelViewMonthlySalary On mount :", props);
      SetSaveData(props.data.record);
      myModal = new bootstrap.Modal(
        document.getElementById("ModelViewMonthlySalary"),
        {}
      );
      myModal.show();
     
    }
  }, [props.data.is_open]);

 

  return (
    <div
      className="modal fade"
      id="ModelViewMonthlySalary"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="  modal-title" id="ModalLabel">
              {props.data.is_read ? "User Monthly Salary Details" : "Deleted User Monthly Salary"}
            </h5>
            <button
              type="button"
              className="btn-close"
              // data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            ></button>
          </div>
          <div className="modal-body">

            <div className="row cursor">
              <div className="col-2">
                {save_data.profile_picture == null ? (
                <img src={require("../../../assets/img/profile.png")} className="w-100 img-radius" />
                ): (
                <img src={save_data.profile_picture} className="w-100 img-radius" />
                )}
              </div>
              <div className="col-10">
                <h6>{save_data.user}</h6>
                <p className="v-small">@{save_data.username}</p>
                <p className="text-dark"><i className="fas fa-rupee-sign pe-2"></i>{save_data.amount}</p>
              </div>
            </div>
                     
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light-outline"
              // data-bs-dismiss="modal"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
